// src/App.tsx
import { RouterProvider, createHashRouter } from "react-router-dom";
import { routeDetail } from "./route";
import "assets/scss/app.scss";
import 'assets/scss/_spacing.scss';  // Import your custom SCSS theme 
import 'assets/scss/_theme.scss';  // Import your custom SCSS theme
import 'assets/scss/_colors.scss';  // Import your custom SCSS theme
import { ConfigProvider } from "antd";
import Layouts from "./component/layout/layout";

const router = createHashRouter(routeDetail);

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#031B76", // Set the primary color globally
          colorError: "#D40303", // Set danger color 
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
